import React from "react";
import { FiHash } from "react-icons/fi";
import {
  isProtocolRequired,
  parseProtocolPreferences,
} from "../../../../utils/protocolPreferences";

export default function CaseProtocolSection({
  protocolPreferences,
  protocolNumber,
  protocolInput,
  setProtocolInput,
  canEdit,
  protocolSubmitting,
  onProtocolBlur,
}) {
  const prefs = parseProtocolPreferences(protocolPreferences);
  if (!prefs.useProtocolNumber) return null;

  const required = isProtocolRequired(prefs);
  const displayNumber = (protocolNumber || "").trim();
  const missing = required && !displayNumber;

  return (
    <div className="card mb-6 overflow-hidden">
      <div className="px-5 py-3.5 border-b border-slate-200 bg-slate-50/60">
        <h2 className="text-xs font-semibold text-slate-700 uppercase tracking-wider flex items-center gap-2 flex-wrap">
          <FiHash className="text-clinic-600" size={15} aria-hidden />
          Numri i protokollit
        </h2>
      </div>
      <div className="px-5 py-4">
        {canEdit ? (
          <div className="flex-1 min-w-0">
            <label htmlFor="case-protocol" className="label">
              Numri i protokollit
            </label>
            <input
              id="case-protocol"
              type="text"
              maxLength={100}
              value={protocolInput}
              onChange={(e) => setProtocolInput(e.target.value)}
              onBlur={onProtocolBlur}
              className="input"
              placeholder="p.sh. 2026/0142"
              disabled={protocolSubmitting}
            />
          </div>
        ) : (
          <div>
            <p className="text-[11px] font-medium text-slate-500 uppercase tracking-wide">
              Numri aktual
            </p>
            <p
              className={`mt-1 text-sm font-semibold ${
                missing ? "text-amber-700" : "text-slate-900"
              }`}
            >
              {displayNumber || (required ? "Nuk është vendosur ende" : "—")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
